<template>
  <div class="page page-landing" v-scroll-spy="scrollPos">

    <div class="columns is-gapless is-multiline" data-aos="fade-up" data-aos-once="true" v-if="banner">
      <div class="column is-12">

        <!-- tablet onwards -->
        <div class="top-image-wrapper is-hidden-mobile" :style="{ backgroundImage: `url(${banner.image ? banner.image.path : ''})` }">
          <div class="container">
            <div class="vcentered banner" data-aos="fade-right" data-aos-once="true">
              <markdown v-if="banner.content" :source="banner.content" />
              <!-- <div class="stitle font-bold text-uppercase color-blue" style="">
                Collection And Probation Services
              </div>
              <div class="ssubtitle" style="">
                Since 2005 with over 65 years <br />
                of combined experience
              </div>
              <div class="stext font-title" style="">
                CMS is registered with the Misdemeanor Probation<br />
                Oversight Unit of Georgia (MPOU)
              </div> -->
            </div>
          </div>
        </div>

        <!-- mobile only -->
        <img :src="banner.image_mobile && banner.image_mobile.path" class="img-responsive is-hidden-tablet" style="display:block;" />
        <div class="top-image-wrapper is-hidden-tablet">
          <div class="container">
            <div class="vcentered banner" data-aos="fade-right" data-aos-once="true">
              <markdown v-if="banner && banner.content" :source="banner.content" />
              <!-- <div class="stitle font-bold text-uppercase color-blue" style="">
                Collection And Probation Services
              </div>
              <div class="ssubtitle" style="">
                Since 2005 with over 65 years <br />
                of combined experience
              </div>
              <div class="stext font-title" style="">
                CMS is registered with the Misdemeanor Probation<br />
                Oversight Unit of Georgia (MPOU)
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="statement && contacts">
      <div class="columns is-gapless content">
        <div class="column is-12 extra-padded">
          <div class="columns">
            <div class="column is-6">
              <div class="title">
                {{ statement.title }}
              </div>
              <markdown v-if="statement.content" :source="statement.content" />
              <!-- <div class="text">
                {{ statement.content }}
              </div> -->
            </div>
            <div class="column is-6">
              <div class="title">
                {{ contacts.title }}
              </div>
              <markdown v-if="contacts.content" :source="contacts.content" />
              <!-- <div class="subtitle">
                Probationers
              </div>
              <div class="text">
                Please see Contact Us for your respective office and a listing of officers.
              </div>
              <div class="subtitle">
                Judges, Attorneys, Court Personnel, City/County Officials
              </div>
              <div class="text">
                Please contact our President/CEO Teresa McClellan here.
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container note color-blue color-yellow-bg" style="margin-top:30px;margin-bottom:50px;" data-aos="fade-right" data-aos-once="true" v-if="note">
      <div class="columns is-gapless">
        <div class="column is-12 smessage" style="padding:30px;">
          <markdown v-if="note.content" :source="note.content" />
        </div>
      </div>
    </div>

    <div class="container is-fluid color-gray-lighter-bg" style="padding-top:15px;padding-bottom:45px;margin-left:0;margin-right:0;" >
      <div class="container content">
        <div class="columns has-text-centered">
          <div class="column is-4"
            v-for="(hotlink, index) in hotlinks"
            :key="`${hotlink.id}`"
            data-aos="fade-up" data-aos-once="true" :data-aos-delay="(index + 1) * 200">
            <a :href="`${hotlink.route}`">
              <img :src="hotlink.image ? hotlink.image.path : ''" class="img-responsive" />
              <div class="title tight margin-top">
                {{ hotlink.title }}
              </div>
              <div class="text tight margin-top">
                {{ hotlink.content }}
              </div>
            </a>
          </div>
          <!-- <div class="column is-4" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
            <a href="#">
              <img src="../assets/image-02.jpg" class="img-responsive" />
              <div class="title tight margin-top">
                Our Services
              </div>
              <div class="text tight margin-top">
                Collection and probation services
              </div>
            </a>
          </div>
          <div class="column is-4" data-aos="fade-up" data-aos-once="true" data-aos-delay="400">
            <a href="#">
              <img src="../assets/image-03.jpg" class="img-responsive" />
              <div class="title tight margin-top">
                Helpful Links
              </div>
              <div class="text tight margin-top">
                Some useful links for more information regarding collection and probation services
              </div>
            </a>
          </div>
          <div class="column is-4" data-aos="fade-up" data-aos-once="true" data-aos-delay="600">
            <a href="#">
              <img src="../assets/image-04.jpg" class="img-responsive" />
              <div class="title tight margin-top">
                FAQ
              </div>
              <div class="text tight margin-top">
                List of frequently asked questions
              </div>
            </a>
          </div> -->
        </div>
      </div>
    </div>

    <div class="slick-wrapper" data-aos="fade-in" data-aos-once="true" v-if="testimonials">
      <slick ref="slick" :options="slickOptions">
        <div class="item-wrapper"
          v-for="(item, index) in testimonials"
          :key="`${item.id}`"
          :caption="item.title">
          <div class="container is-fluid" style="padding-top:30px;padding-bottom:30px;margin-left:0;margin-right:0;">
            <div class="container content">
              <div class="columns is-centered has-text-centered">
                <div class="column is-7">
                  <div class="title tight margin-top">
                    {{ item.title }}
                  </div>
                  <div class="text tight margin-top">
                    {{ item.content }}
                  </div>
                  <div class="subtitle margin-top">
                    {{ item.link }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </lightbox> -->
      </slick>
    </div>

    <main-dialog
      :visible="dialogVisible"
      :data="message || {}"
      @onClose="onCloseDialog"
    />

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import MasonryYoutube from '@/components/MasonryYoutube.vue'
import AboutSection from '@/components/AboutSection.vue'
import ShowSection from '@/components/ShowSection.vue'
import NewsletterSection from '@/components/NewsletterSection.vue'
import InstagramSection from '@/components/InstagramSection.vue'
import ContactSection from '@/components/ContactSection.vue'
import MainDialog from '@/components/MainDialog.vue'

import Site from '@/apis/Site'

export default {
  name: 'landing',
  components: {
    MasonryYoutube,
    AboutSection,
    ShowSection,
    NewsletterSection,
    InstagramSection,
    ContactSection,
    Slick,
    Markdown,
    MainDialog
  },
  data () {
    return {
      isDesktop: true,
      loading: false,
      error: undefined,
      scrollPos: 0,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: false,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 1008,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }, {
            // 768 = tablet (not break yet)
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }
        ]
      },
      banner: undefined,
      statement: undefined,
      contacts: undefined,
      note: undefined,
      hotlinks: undefined,
      testimonials: undefined,
      message: undefined,
      dialogVisible: true
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    // console.log('created Landing.vue')
  },
  mounted () {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getBanner()
    this.getStatement()
    this.getContacts()
    this.getNote()
    this.getHotlinks()
    this.getTestimonials()
    this.getMessage()
  },
  methods: {
    async getBanner () {
      try {
        let data
        // banner
        this.banner = undefined
        data = await Site.infoNamed('landing-banner')
        if (data && data[0]) {
          data = data[0]
          if (data.image && data.image.path) {
            data.img = await EventBus.loadImage(data.image.path)
          }
          if (data.image_mobile && data.image_mobile.path) {
            data.imgMobile = await EventBus.loadImage(data.image_mobile.path)
          }
          this.banner = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getStatement () {
      try {
        let data
        // statement
        this.statement = undefined
        data = await Site.infoNamed('landing-statement')
        if (data && data[0]) {
          data = data[0]
          this.statement = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getContacts () {
      try {
        let data
        // contacts
        this.contacts = undefined
        data = await Site.infoNamed('landing-contacts')
        if (data && data[0]) {
          data = data[0]
          this.contacts = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getNote () {
      try {
        let data
        // note
        this.note = undefined
        data = await Site.infoNamed('landing-note')
        if (data && data[0]) {
          data = data[0]
          this.note = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getHotlinks () {
      try {
        let data
        // hotlinks
        this.hotlinks = undefined
        data = await Site.hotlinkNameLike('hotlink-')
        if (data && data.length > 0) {
          this.hotlinks = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getTestimonials () {
      try {
        let data
        // testimonials (service table in october db)
        this.testimonials = undefined
        data = await Site.services()
        if (data && data.length > 0) {
          this.testimonials = data
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    async getMessage () {
      try {
        let data
        // message
        this.message = undefined
        data = await Site.infoNamed('message')
        if (data != null && data.length > 0 && Array.isArray) {
          data = data[0]
        }
        if (data) {
          this.message = data
          this.$nextTick(() => {
            this.dialogVisible = true
          })
        }
      } catch (error) {
        console.log('info error', error)
      }
    },

    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    next () {
      if (this.$refs.slick) {
        this.$refs.slick.next()
      }
    },
    prev () {
      if (this.$refs.slick) {
        this.$refs.slick.prev()
      }
    },
    reInit () {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick()
      }
    },

    onCloseDialog: function () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-landing {
  padding-top: 0;
  padding-bottom: 30px;

  // the magic
  .top-image-wrapper {
    // background-image: url("../assets/image-01.jpg");
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: 100% auto;
    width: 100%;

    &.is-hidden-tablet {
      background-image: none;
      background: $color-primary-blue;
    }

    .container {
      // background-color:blue;
      height: 400px;
      position: relative;

      @media screen and (max-width: ($tablet - 1)) {
        height: auto;
      }

      .vcentered {
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        padding-left: 1.75rem;
        // padding-right: 1.75rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 37%;

        @media screen and (max-width: ($tablet - 1)) {
          margin-left: 0rem;
          margin-right: 0rem;
          padding-top: 30px;
          padding-bottom: 30px;
          position: relative;
          top: 0%;
          transform: none;
          width: calc(100% - 1.4rem);
        }

        h2 {
          word-wrap: break-word;
          font-size: 1.3em;
          font-family: $font-family;
          @media screen and (max-width: ($tablet - 1)) {
            font-size: 1.1em;
            color: $color-primary-yellow;
          }
        }

        h1 {
          word-wrap: break-word;
          font-size: 1.6em;
          font-weight: normal;
          text-transform: none;
          color: white;
          margin-top: 5px;
          font-family: $font-family-title;
          @media screen and (max-width: ($tablet - 1)) {
            font-size: 1.4em;
          }
        }

        p {
          font-size: 1.1em;
          color: white;
          margin-top: 5px;
          @media screen and (max-width: ($tablet - 1)) {
            font-size: 1.0em;
          }
        }
      }
    }
  }

  .note {
    a {
      color: $color-primary-blue;
      opacity: 0.8;

      &:hover {
        opacity: 1.0;
      }
    }
  }

  .content {
    padding-top: 30px;

    @media screen and (max-width: ($desktop - 1)) {
      padding-left: 1.75rem;
      padding-right: 1.75rem;
    }

    img {
      max-width: 100%;
      // @media screen and (max-width: ($tablet - 1)) {
      //   max-width: 400px;
      // }
    }

    .title {
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
    .subtitle, h3 {
      margin-top: 30px;
      margin-bottom: 0;
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
    .text, p {
      margin-top: 8px;
      margin-bottom: 20px;
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
  }

  .column {
    &.extra-padded {
      padding-left: 35px;
      padding-right: 35px;
      @media screen and (max-width: ($desktop - 1)) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .smessage {
    padding: 25px 50px;
    @media screen and (max-width: ($desktop - 1)) {
      padding: 25px 43px;
    }
  }

  img[src*="#thumbnail"] {
    width: 150px;
    height: auto;
  }

  .slick-wrapper {
    overflow-x: hidden;
  }

  .top {
    padding: 10px;
    background: $color-gray-mid;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    transition: 1s linear;
    position: relative;
    width: 35px;
    height: 35px;

    span {
      position: absolute;
      top: 18px;
      left: 50%;
      width: 15px;
      height: 15px;
      margin-left: -7px;
      border-left: 1px solid $color-white;
      border-bottom: 1px solid $color-white;
      transform: rotate(135deg);
      animation: arrow-up-animate 3s infinite;
      box-sizing: border-box;
    }
    @keyframes arrow-up-animate {
      0% {
        transform: rotate(135deg) translate(0, 0);
      }
      30% {
        transform: rotate(135deg) translate(-10px, 10px);
      }
      80% {
        transform: rotate(135deg) translate(0, 0);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Landing.vue?0149ec24